/**
 * @generated SignedSource<<130ca463cf11c4821f42c29e4a040693>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type partnerTemplateCardCarouselContentfulRelayFragment$data = ReadonlyArray<{
  readonly sys: {
    readonly id: string;
  };
  readonly urlSlug: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"partnerTemplateCardContentfulRelayFragment">;
  readonly " $fragmentType": "partnerTemplateCardCarouselContentfulRelayFragment";
}>;
export type partnerTemplateCardCarouselContentfulRelayFragment$key = ReadonlyArray<{
  readonly " $data"?: partnerTemplateCardCarouselContentfulRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"partnerTemplateCardCarouselContentfulRelayFragment">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "partnerTemplateCardCarouselContentfulRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Sys",
      "kind": "LinkedField",
      "name": "sys",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlSlug",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "partnerTemplateCardContentfulRelayFragment"
    }
  ],
  "type": "ProductTemplate",
  "abstractKey": null
};

(node as any).hash = "a57260ce7f63b1ced209b80cea6f087b";

export default node;
